// import React from "react";
// import {
//   FaBell,
//   FaSyncAlt,
//   FaBoxOpen,
// } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import {
//   MdPendingActions,
//   MdOutlineShoppingCartCheckout,
// } from "react-icons/md";
// import { useEffect, useState } from "react";
// import axios from "axios";

// const Notification = () => {
// const navigate = useNavigate();
  
// const [lowStock, setLowStock] = useState([]);
// const clientId = JSON.parse(localStorage.getItem("user_data"))?.id;

// useEffect(() => {
//   fetchLowStock();
// }, []);
// const [loading, setLoading] = useState(false);


// const fetchLowStock = async () => {
//   try {
//     setLoading(true);

//     await new Promise(resolve => setTimeout(resolve, 2000));
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
//     );

//     const filteredData = res.data.filter(
//       (item) => Number(item.stock) <= Number(item.min_to_maintain)
//     );
// console.log( "res",res.data)
//     setLowStock(filteredData);
//   } catch (error) {
//     console.log(error);
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <div className="container-fluid py-3">
//       <div className="card shadow border-0 rounded-4">
        
//         <div
//           className="card-header d-flex justify-content-between align-items-center"
//           style={{ background: "#d9e4f1" }}
//         >
//           <h2 className="fw-bold mb-0">
//             <FaBell className=" me-2" style={{color:"var(--primary-color)"}}/>
//             Notifications
//           </h2>


// <button
//   className="btn rounded-pill fw-bold px-4 py-2"
//   style={{
//     background: "var(--primary-color)",
//     color: "#fff",
//     border: "none",
//   }}
//   onClick={fetchLowStock}
//   disabled={loading}
// >
//   <FaSyncAlt className={`me-2 ${loading ? "spin" : ""}`} />
//   {loading ? "Refreshing..." : "REFRESH"}
// </button>
//         </div>

        
//         <div className="card-body">
//           <div className="row g-3">
        
//             <div className="col-md-4">
//               {/* <div className="card shadow-sm border-0 rounded-4 h-100"> */}
//               <div
//   className="card notification-card h-100"
//   style={{
//     border: "2px solid #ff6b6b",
//     borderLeft: "8px solid #ff4d4f",
//     borderRadius: "18px",
//     transition: "0.3s",
//     cursor: "pointer",
//     overflow: "hidden",
//   }}
//   onMouseEnter={(e) => {
//     e.currentTarget.style.transform = "translateY(-6px)";
//     e.currentTarget.style.boxShadow = "0 15px 30px rgba(255,77,79,.25)";
//   }}
//   onMouseLeave={(e) => {
//     e.currentTarget.style.transform = "translateY(0)";
//     e.currentTarget.style.boxShadow = "";
//   }}
// >
//                 <div className="card-body d-flex align-items-center">
//                   <div
//                     className="p-3 rounded-3 me-3"
//                     style={{ background: "#ffe1e1" }}
//                   >
//                     <FaBoxOpen size={28} className="text-danger" />
//                   </div>

//                   <div>
//                     <h5 className="fw-bold mb-1">Low Stock</h5>
//                    <h4 className="text-secondary mb-0">
//   {lowStock.length} Items
// </h4>
//                   </div>
//                 </div>
//               </div>
//             </div>

     
//           <div className="col-md-4">
// <div
//   className="card h-100"
//   style={{
//     border: "2px solid #845ef7",
//     borderLeft: "8px solid #7048e8",
//     borderRadius: "18px",
//     transition: ".3s",
//     cursor: "pointer",
//     overflow: "hidden",
//   }}

//    onMouseEnter={(e) => {
//     e.currentTarget.style.transform = "translateY(-6px)";
//     e.currentTarget.style.boxShadow = "0 15px 30px rgba(184, 77, 255, 0.25)";
//   }}
//   onMouseLeave={(e) => {
//     e.currentTarget.style.transform = "translateY(0)";
//     e.currentTarget.style.boxShadow = "";
//   }}

//   onClick={() => navigate('/estimate-to-sale')}
// >
//     <div className="card-body d-flex align-items-center">
//       <div
//         className="p-3 rounded-3 me-3"
//         style={{ background: "#e4dbff" }}
//       >
//         <MdPendingActions
//           size={32}
//           className="text-primary"
//         />
//       </div>

//       <div>
//         <h5 className="fw-bold mb-1">Pending</h5>
//         <h4 className="text-secondary mb-0">
//           Estimates
//         </h4>
//       </div>
//     </div>
//   </div>
// </div>


//           <div className="col-md-4">
            
//   <div
  
//   className="card h-100"
//   style={{
//     border: "2px solid #f59f00",
//     borderLeft: "8px solid #fab005",
//     borderRadius: "18px",
//     transition: ".3s",
//     cursor: "pointer",
//     overflow: "hidden",
//   }}
  

//     onClick={() => navigate("/Addpurchase")}
//     onMouseEnter={(e) => {
//       e.currentTarget.style.transform = "translateY(-5px)";
      
//     e.currentTarget.style.boxShadow = "0 15px 30px rgba(255, 237, 77, 0.25)";
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow = "";
//     }}
//   >
//     <div className="card-body d-flex align-items-center">
//       <div
//         className="p-3 rounded-3 me-3"
//         style={{ background: "#fff1c7" }}
//       >
//         <MdOutlineShoppingCartCheckout
//           size={32}
//           className="text-warning"
//         />
//       </div>

//       <div>
//         <h5 className="fw-bold mb-1">Create</h5>
//         <h4 className="text-secondary mb-0">
//           Purchase
//         </h4>
//       </div>
//     </div>
//   </div>
// </div>
//           </div>

      
//           <div className="mt-4">
//             <h2
//               className="fw-bold mb-3"
//               // style={{ fontFamily: "cursive" }}
//             >
//               All Notifications
//             </h2>

          
//           {lowStock.length > 0 ? (
//   lowStock.map((item) => (
//     <div
//       key={item.id}
//       className="p-3 rounded-3 mb-3"
//       style={{
//         background: "#f8f8f8",
//         borderLeft: "4px solid var(--primary-color)",
//       }}
//     >
//       <h5 className="fw-bold " style={{
//         color: "var(--primary-color)",
    
//       }}>
//         Low Stock Alert
//       </h5>

//       <div
//         className="p-2 rounded"
//         style={{ background: "#fff" }}
//       >
//         <strong>{item.name}</strong>
//         <br />
//         Current Stock: {item.stock}
//         <br />
//         Minimum Stock: {item.min_to_maintain}
//       </div>
//     </div>
//   ))
// ) : (
//   <div className="alert alert-success">
//     No Low Stock Items Found
//   </div>
// )}

           

             
              
//             </div>
//           </div>
//         </div>
//       </div>
   
//   );
// };

// export default Notification;


import React, { useEffect, useState } from "react";
import {
  FaBell,
  FaSyncAlt,
  FaBoxOpen,
  FaCheckCircle,
  FaShoppingCart,
  FaFileInvoice,
  FaCog,
  FaEllipsisV,
  FaEye,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import {
  MdPendingActions,
  MdOutlineShoppingCartCheckout,
} from "react-icons/md";

import axios from "axios";

const Notification = () => {
  const navigate = useNavigate();

  const [lowStock, setLowStock] = useState([]);
  const [loading, setLoading] = useState(false);

  const clientId = JSON.parse(
    localStorage.getItem("user_data")
  )?.id;

  // =====================================================
  // SAME LOGIC
  // =====================================================

  useEffect(() => {
    fetchLowStock();
  }, []);

  const fetchLowStock = async () => {
    try {
      setLoading(true);

      await new Promise((resolve) =>
        setTimeout(resolve, 2000)
      );

      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${clientId}`
      );

      const filteredData = res.data.filter(
        (item) =>
          Number(item.stock) <=
          Number(item.min_to_maintain)
      );

      console.log("res", res.data);

      setLowStock(filteredData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <div className="notification-page">

      <style>{`

        /* =================================================
           PAGE
        ================================================= */

        .notification-page {
          width: 100%;
          min-height: 100vh;
          background: #f5f8fc;
          padding: 12px 14px 25px;
          overflow-x: hidden;
        }

        .notification-wrapper {
          width: 100%;
          max-width: 1450px;
          margin: auto;
        }

        /* =================================================
           HEADER
        ================================================= */

        .notification-header {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 15px;
          padding: 4px 2px 12px;
        }

        .notification-title-area {
          display: flex;
          align-items: center;
          gap: 9px;
        }

        .notification-title-icon {
          width: 38px;
          height: 38px;
          border-radius: 9px;
          background: #edf5ff;
          color: var(--primary-color, #1677ff);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .notification-title-icon svg {
          font-size: 19px;
        }

        .notification-header h2 {
          margin: 0;
          color: #16233b;
          font-size: 20px;
          font-weight: 800;
          line-height: 1.15;
        }

        .notification-header p {
          margin: 3px 0 0;
          color: #7d8798;
          font-size: 9px;
        }

        .notification-header-actions {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .notification-refresh-btn {
          height: 34px;
          padding: 0 14px;
          border: 1px solid #dce5ef;
          border-radius: 7px;
          background: #fff;
          color: var(--primary-color, #1677ff);
          font-size: 9px;
          font-weight: 700;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          cursor: pointer;
          white-space: nowrap;
        }

        .notification-refresh-btn:hover {
          background: #f5f9ff;
        }

        .notification-refresh-btn:disabled {
          opacity: .7;
          cursor: not-allowed;
        }

        .notification-settings {
          width: 34px;
          height: 34px;
          border: 1px solid #dce5ef;
          background: #fff;
          border-radius: 7px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #65748a;
          cursor: pointer;
        }

        /* =================================================
           SUMMARY CARDS
        ================================================= */

        .notification-summary-grid {
          display: grid;
          grid-template-columns:
            repeat(3, minmax(0, 1fr));
          gap: 10px;
          margin-bottom: 12px;
        }

        .notification-summary-card {
          min-width: 0;
          min-height: 78px;
          border: 1px solid #e3eaf2;
          border-radius: 9px;
          background: #fff;
          padding: 11px;
          display: flex;
          align-items: center;
          gap: 10px;
          box-shadow: 0 2px 8px rgba(30, 55, 90, .04);
          cursor: pointer;
          transition: .2s ease;
        }

        .notification-summary-card:hover {
          transform: translateY(-2px);
          box-shadow:
            0 8px 20px rgba(30, 55, 90, .09);
        }

        .notification-summary-icon {
          width: 43px;
          height: 43px;
          min-width: 43px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .notification-summary-icon svg {
          font-size: 19px;
        }

        .notification-summary-content {
          min-width: 0;
        }

        .notification-summary-number {
          margin: 0;
          color: #18253c;
          font-size: 17px;
          font-weight: 800;
          line-height: 1;
        }

        .notification-summary-title {
          margin: 4px 0 0;
          color: #56657a;
          font-size: 8px;
          font-weight: 700;
        }

        .notification-summary-link {
          margin-top: 3px;
          color: var(--primary-color, #1677ff);
          font-size: 6px;
          font-weight: 700;
        }

        /* =================================================
           TABS
        ================================================= */

        .notification-content-card {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 9px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(30, 55, 90, .04);
        }

        .notification-tabs-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 9px 11px;
          border-bottom: 1px solid #edf1f5;
        }

        .notification-tabs {
          display: flex;
          align-items: center;
          gap: 4px;
          min-width: 0;
          overflow-x: auto;
          scrollbar-width: none;
        }

        .notification-tabs::-webkit-scrollbar {
          display: none;
        }

        .notification-tab {
          border: 0;
          background: transparent;
          padding: 6px 9px;
          border-radius: 5px;
          color: #718096;
          font-size: 7px;
          font-weight: 700;
          white-space: nowrap;
          cursor: pointer;
        }

        .notification-tab.active {
          background: #edf5ff;
          color: var(--primary-color, #1677ff);
        }

        .notification-sort {
          flex-shrink: 0;
          height: 28px;
          border: 1px solid #e1e7ef;
          border-radius: 5px;
          background: #fff;
          padding: 0 8px;
          color: #5f6d82;
          font-size: 7px;
          outline: none;
        }

        /* =================================================
           NOTIFICATION LIST
        ================================================= */

        .notification-list {
          width: 100%;
        }

        .notification-item {
          width: 100%;
          min-height: 66px;
          padding: 9px 11px;
          display: flex;
          align-items: center;
          gap: 10px;
          border-bottom: 1px solid #edf1f5;
          transition: background .2s ease;
        }

        .notification-item:last-child {
          border-bottom: 0;
        }

        .notification-item:hover {
          background: #fbfcff;
        }

        .notification-item-icon {
          width: 37px;
          height: 37px;
          min-width: 37px;
          border-radius: 7px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .notification-item-icon svg {
          font-size: 16px;
        }

        .notification-item-main {
          min-width: 0;
          flex: 1;
        }

        .notification-item-title-row {
          display: flex;
          align-items: center;
          gap: 5px;
          flex-wrap: wrap;
        }

        .notification-item-title {
          margin: 0;
          color: #26344b;
          font-size: 8px;
          font-weight: 800;
        }

        .notification-urgent {
          padding: 2px 5px;
          border-radius: 7px;
          background: #ffe7e7;
          color: #ef4444;
          font-size: 5px;
          font-weight: 800;
        }

        .notification-item-description {
          margin: 2px 0 0;
          color: #748196;
          font-size: 6.5px;
          line-height: 1.35;
        }

        .notification-item-meta {
          margin-top: 3px;
          color: #9aa4b3;
          font-size: 5.5px;
        }

        .notification-item-right {
          min-width: 100px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 5px;
        }

        .notification-item-date {
          color: #8994a5;
          font-size: 5.5px;
          white-space: nowrap;
        }

        .notification-view-btn {
          height: 24px;
          padding: 0 9px;
          border: 1px solid #cdddf2;
          border-radius: 5px;
          background: #f8fbff;
          color: var(--primary-color, #1677ff);
          font-size: 6px;
          font-weight: 700;
          cursor: pointer;
          white-space: nowrap;
        }

        .notification-more {
          width: 25px;
          height: 25px;
          border: 0;
          background: transparent;
          color: #8994a5;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* =================================================
           EMPTY
        ================================================= */

        .notification-empty {
          padding: 35px 15px;
          text-align: center;
          color: #68768b;
          font-size: 10px;
        }

        /* =================================================
           SPINNER
        ================================================= */

        .notification-spin {
          animation: notificationSpin 1s linear infinite;
        }

        @keyframes notificationSpin {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        /* =================================================
           MOBILE
        ================================================= */

        @media (max-width: 767px) {

          .notification-page {
            padding: 8px 7px 78px;
          }

          .notification-header {
            align-items: flex-start;
            padding-bottom: 9px;
          }

          .notification-title-area {
            gap: 7px;
          }

          .notification-title-icon {
            width: 32px;
            height: 32px;
            min-width: 32px;
          }

          .notification-title-icon svg {
            font-size: 16px;
          }

          .notification-header h2 {
            font-size: 14px;
          }

          .notification-header p {
            font-size: 6px;
            line-height: 1.35;
          }

          .notification-header-actions {
            gap: 4px;
          }

          .notification-refresh-btn {
            width: 32px;
            height: 30px;
            padding: 0;
          }

          .notification-refresh-btn-text {
            display: none;
          }

          .notification-settings {
            width: 30px;
            height: 30px;
          }

          .notification-summary-grid {
            grid-template-columns:
              repeat(3, minmax(0, 1fr));
            gap: 5px;
            margin-bottom: 8px;
          }

          .notification-summary-card {
            min-height: 62px;
            padding: 7px 5px;
            gap: 5px;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
          }

          .notification-summary-icon {
            width: 28px;
            height: 28px;
            min-width: 28px;
          }

          .notification-summary-icon svg {
            font-size: 13px;
          }

          .notification-summary-number {
            font-size: 12px;
          }

          .notification-summary-title {
            margin-top: 2px;
            font-size: 5.5px;
          }

          .notification-summary-link {
            display: none;
          }

          .notification-tabs-row {
            padding: 6px;
          }

          .notification-tabs {
            width: 100%;
          }

          .notification-tab {
            padding: 5px 6px;
            font-size: 6px;
          }

          .notification-sort {
            display: none;
          }

          .notification-item {
            min-height: 63px;
            padding: 8px 7px;
            gap: 7px;
          }

          .notification-item-icon {
            width: 32px;
            height: 32px;
            min-width: 32px;
          }

          .notification-item-icon svg {
            font-size: 13px;
          }

          .notification-item-title {
            font-size: 7px;
          }

          .notification-item-description {
            font-size: 5.5px;
          }

          .notification-item-meta {
            font-size: 5px;
          }

          .notification-item-right {
            min-width: auto;
            gap: 3px;
          }

          .notification-item-date {
            display: none;
          }

          .notification-view-btn {
            height: 22px;
            padding: 0 6px;
            font-size: 5px;
          }

          .notification-more {
            width: 20px;
            height: 20px;
          }
        }

        /* =================================================
           VERY SMALL MOBILE
        ================================================= */

        @media (max-width: 380px) {

          .notification-item-description {
            max-width: 160px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .notification-item-right {
            min-width: 55px;
          }

          .notification-view-btn {
            padding: 0 5px;
          }

        }
          /* =====================================================
   FONT SIZE FIX - READABLE UI
===================================================== */

/* Header */
.notification-header h2 {
  font-size: 22px !important;
}

.notification-header p {
  font-size: 11px !important;
}

/* Refresh */
.notification-refresh-btn {
  font-size: 11px !important;
}

/* Summary cards */
.notification-summary-number {
  font-size: 20px !important;
}

.notification-summary-title {
  font-size: 10px !important;
}

.notification-summary-link {
  font-size: 8px !important;
}

/* Tabs */
.notification-tab {
  font-size: 9px !important;
}

/* Notification list */
.notification-item-title {
  font-size: 11px !important;
}

.notification-urgent {
  font-size: 7px !important;
}

.notification-item-description {
  font-size: 9px !important;
}

.notification-item-meta {
  font-size: 8px !important;
}

.notification-item-date {
  font-size: 8px !important;
}

.notification-view-btn {
  font-size: 8px !important;
}

/* Empty */
.notification-empty {
  font-size: 12px !important;
}


/* =====================================================
   MOBILE FONT SIZE
===================================================== */

@media (max-width: 767px) {

  .notification-header h2 {
    font-size: 17px !important;
  }

  .notification-header p {
    font-size: 8px !important;
  }

  .notification-summary-number {
    font-size: 16px !important;
  }

  .notification-summary-title {
    font-size: 8px !important;
  }

  .notification-tab {
    font-size: 8px !important;
    padding: 6px 8px !important;
  }

  .notification-item-title {
    font-size: 9px !important;
  }

  .notification-urgent {
    font-size: 6px !important;
  }

  .notification-item-description {
    font-size: 7.5px !important;
    line-height: 1.4 !important;
  }

  .notification-item-meta {
    font-size: 7px !important;
  }

  .notification-view-btn {
    font-size: 7px !important;
  }

}


/* =====================================================
   SMALL MOBILE
===================================================== */

@media (max-width: 380px) {

  .notification-header h2 {
    font-size: 16px !important;
  }

  .notification-header p {
    font-size: 7.5px !important;
  }

  .notification-summary-number {
    font-size: 15px !important;
  }

  .notification-summary-title {
    font-size: 7px !important;
  }

  .notification-tab {
    font-size: 7px !important;
  }

  .notification-item-title {
    font-size: 8.5px !important;
  }

  .notification-item-description {
    font-size: 7px !important;
  }

  .notification-item-meta {
    font-size: 6.5px !important;
  }

  .notification-view-btn {
    font-size: 6.5px !important;
  }

}

      `}</style>

      <div className="notification-wrapper">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="notification-header">

          <div className="notification-title-area">

            <div className="notification-title-icon">
              <FaBell />
            </div>

            <div>
              <h2>
                Notifications
              </h2>

              <p>
                Stay updated with important alerts
                and activities.
              </p>
            </div>

          </div>

          <div className="notification-header-actions">

            <button
              type="button"
              className="notification-refresh-btn"
              onClick={fetchLowStock}
              disabled={loading}
            >
              <FaSyncAlt
                className={
                  loading
                    ? "notification-spin"
                    : ""
                }
              />

              <span className="notification-refresh-btn-text">
                {loading
                  ? "Refreshing..."
                  : "Refresh"}
              </span>
            </button>

            <button
              type="button"
              className="notification-settings"
            >
              <FaCog size={11} />
            </button>

          </div>

        </div>

        {/* =================================================
            SUMMARY
        ================================================= */}

        <div className="notification-summary-grid">

          {/* LOW STOCK */}

          <div
            className="notification-summary-card"
            onClick={() =>
              navigate("/inventory")
            }
          >

            <div
              className="notification-summary-icon"
              style={{
                background: "#ffe9ed",
                color: "#f04455",
              }}
            >
              <FaBoxOpen />
            </div>

            <div className="notification-summary-content">

              <p className="notification-summary-number">
                {lowStock.length}
              </p>

              <p className="notification-summary-title">
                Low Stock
              </p>

              <div className="notification-summary-link">
                View →
              </div>

            </div>

          </div>

          {/* PENDING ESTIMATES */}

          <div
            className="notification-summary-card"
            onClick={() =>
              navigate("/estimate-to-sale")
            }
          >

            <div
              className="notification-summary-icon"
              style={{
                background: "#f0eaff",
                color: "#7048e8",
              }}
            >
              <MdPendingActions />
            </div>

            <div className="notification-summary-content">

              <p className="notification-summary-number">
                0
              </p>

              <p className="notification-summary-title">
                Pending Estimates
              </p>

              <div className="notification-summary-link">
                View →
              </div>

            </div>

          </div>

          {/* PENDING PURCHASE */}

          <div
            className="notification-summary-card"
            onClick={() =>
              navigate("/Addpurchase")
            }
          >

            <div
              className="notification-summary-icon"
              style={{
                background: "#fff4d8",
                color: "#f59f00",
              }}
            >
              <MdOutlineShoppingCartCheckout />
            </div>

            <div className="notification-summary-content">

              <p className="notification-summary-number">
                0
              </p>

              <p className="notification-summary-title">
                Pending Purchases
              </p>

              <div className="notification-summary-link">
                View →
              </div>

            </div>

          </div>

        </div>

        {/* =================================================
            ALL NOTIFICATIONS
        ================================================= */}

        <div className="notification-content-card">

          {/* TABS */}

          <div className="notification-tabs-row">

            <div className="notification-tabs">

              <button
                type="button"
                className="notification-tab active"
              >
                All ({lowStock.length})
              </button>

              <button
                type="button"
                className="notification-tab"
              >
                Low Stock ({lowStock.length})
              </button>

              <button
                type="button"
                className="notification-tab"
              >
                Estimates (0)
              </button>

              <button
                type="button"
                className="notification-tab"
              >
                Purchases (0)
              </button>

              <button
                type="button"
                className="notification-tab"
              >
                System (0)
              </button>

            </div>

            <select className="notification-sort">
              <option>
                Latest First
              </option>

              <option>
                Oldest First
              </option>
            </select>

          </div>

          {/* =================================================
              LIST
          ================================================= */}

          <div className="notification-list">

            {lowStock.length > 0 ? (

              lowStock.map((item) => (

                <div
                  key={item.id}
                  className="notification-item"
                >

                  <div
                    className="notification-item-icon"
                    style={{
                      background: "#ffe8ec",
                      color: "#ef4054",
                    }}
                  >
                    <FaBoxOpen />
                  </div>

                  <div className="notification-item-main">

                    <div className="notification-item-title-row">

                      <h5 className="notification-item-title">
                        Low Stock Alert
                      </h5>

                      <span className="notification-urgent">
                        Urgent
                      </span>

                    </div>

                    <p className="notification-item-description">
                      {item.name} is running low.
                      Only {item.stock} items left
                      in stock.
                    </p>

                    <div className="notification-item-meta">
                      Inventory
                    </div>

                  </div>

                  <div className="notification-item-right">

                    <span className="notification-item-date">
                      {new Date().toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }
                      )}
                    </span>

                    <button
                      type="button"
                      className="notification-view-btn"
                      onClick={() =>
                        navigate("/items")
                      }
                    >
                      <FaEye
                        size={7}
                        className="me-1"
                      />
                      View Item
                    </button>

                  </div>

                  <button
                    type="button"
                    className="notification-more"
                  >
                    <FaEllipsisV size={9} />
                  </button>

                </div>

              ))

            ) : (

              <div className="notification-empty">

                <FaCheckCircle
                  size={28}
                  className="text-success mb-2"
                />

                <div>
                  No Low Stock Items Found
                </div>

              </div>

            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default Notification;